import "../../Styles/Classes/ClassesLevelDetail.css";
import { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import ZGA from "../../Assets/ZGA.png";
import CalendarClock from "../../Assets/CalenderClock.png";
import Telegram from "../../Assets/Telegram.png";
import Meet from "../../Assets/Meet.png";
import { ZGAContext } from "../../ZGAContext";

const ClassesLevelDetails = ({ levels }) => {
  const { openModal, user } = useContext(ZGAContext);
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  const goToNext = () => {
    if (currentIndex < levels.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const selectedClass = levels[currentIndex];

  return (
    <div className="classesLevelDetail">
      <div>
        <div>
          <span>
            <img src={ZGA} alt="The Zulaykha Global Academy" />
          </span>
          <div>
            <h1>{selectedClass.name}</h1>
            <p>
              <img src={CalendarClock} alt="Calendar Clock" />
              <span>
                <span>{selectedClass.time[0]}</span>
                <span>{selectedClass.time[1]}</span>
              </span>
            </p>
            <span>
              <span>Venue:</span>
              <img src={Telegram} alt="Telegram" />
              <img src={Meet} alt="Meet" />
            </span>
          </div>
          {selectedClass.classes && (
            <div>
              <span>Classes</span>
              <ul>
                {selectedClass.classes.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          )}
          {selectedClass.subjects && (
            <div>
              <span>Subjects</span>
              <ul>
                {selectedClass.subjects.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div>
          <img src={selectedClass.levelImage} alt="Background" />
          <div className="gradient"></div>
        </div>
      </div>
      <div>
        <h3>Goals:</h3>
        <ul>
          {selectedClass.goals.map((point, i) => (
            <li key={i}>{point}</li>
          ))}
        </ul>
        <button onClick={() => openModal(user ? "rules" : "loginCheckpoint")}>{selectedClass.cButton}</button>
      </div>
      <div>
        <span
          onClick={currentIndex > 0 ? goToPrevious : null}
          className={`navButton ${currentIndex === 0 ? "disabled" : ""}`}
        >
          Previous
        </span>
        <NavLink to="/">Home</NavLink>
        <span
          onClick={currentIndex < levels.length - 1 ? goToNext : null}
          className={`navButton ${currentIndex === levels.length - 1 ? "disabled" : ""}`}
        >
          Next
        </span>
      </div>
    </div>
  );
};

export default ClassesLevelDetails;
